var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { CardContent } from 'material-ui';
import { CustomCard } from '../CustomCard';
import './styles.css';
var Displays = /** @class */ (function (_super) {
    __extends(Displays, _super);
    function Displays(props) {
        var _this = _super.call(this, props) || this;
        _this.changeText = function () {
            _this.setState({ nextStopInInternalDisplay: !_this.state.nextStopInInternalDisplay });
        };
        _this.state = {
            nextStopInInternalDisplay: true,
        };
        return _this;
    }
    Displays.prototype.componentDidMount = function () {
        this.timer = setInterval(this.changeText, 5000);
    };
    Displays.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    Displays.prototype.render = function () {
        var _a = this.props, headsignRoute = _a.headsignRoute, headsignText = _a.headsignText, nextStopName = _a.nextStopName;
        var nextStopInInternalDisplay = this.state.nextStopInInternalDisplay;
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomCard, { className: "display-card" },
                React.createElement(CardContent, { className: "external-display" },
                    React.createElement("span", { className: "external-display__route" }, headsignRoute),
                    React.createElement("span", { className: "external-display__text" }, headsignText))),
            React.createElement(CustomCard, { className: "display-card", style: { margin: '20px 20px 0px 20px' } }, nextStopInInternalDisplay && nextStopName ?
                React.createElement(CardContent, { className: "internal-display internal-display--centered" }, nextStopName) :
                headsignRoute || headsignText ?
                    React.createElement(CardContent, { className: "internal-display" },
                        headsignRoute,
                        " > ",
                        headsignText) :
                    React.createElement(CardContent, { className: "internal-display" }))));
    };
    return Displays;
}(React.Component));
export default connect(function (state) { return state.displays; })(Displays);



//////////////////
// WEBPACK FOOTER
// ./src/components/Displays/index.tsx
// module id = 1776
// module chunks = 0